export const initRootWidth = null;
